export const entitiesEndpoints = {
  entities: "/entity/create",
  entityList: "/entity/list",
  entityDropdown: "/dropdown",
  entityNameDropdown: "/entity/dropdown",
  frequentEntities: "/entity/dropdown/frequent",
  entityVisit: "/entity",
  entityNameValidation: "/entity/name-validation",
  subDomainValidation: "/entity/sub-domain-validation",
  sendOtp: "/verification/email/send-otp",
  details: "/entity",
  deactivate: "/entity",
  myEntities: "/session-management/my-entities",
};
